import {
  GET_CONVERSION_DATA,
  GET_CONVERSION_DATA_SUCCESS,
  GET_CONVERSION_DATA_FAIL,
  GET_CONVERSION_DRILL_DATA,
  GET_CONVERSION_DRILL_DATA_SUCCESS,
  GET_CONVERSION_DRILL_DATA_FAIL
} from '../constants/conversion';

const initialState = {
  drillLoaded: false,
  drillLoading: false,
  drillData: null,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONVERSION_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          loaded: false,
          data: null,
          error: null
        }
      };
    case GET_CONVERSION_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: false,
          data: null,
          error: action.error
        }
      };
    case GET_CONVERSION_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    case GET_CONVERSION_DRILL_DATA:
      return {
        ...state,
        drillLoading: true,
        drillLoaded: false,
        drillData: null,
        error: null
      };
    case GET_CONVERSION_DRILL_DATA_SUCCESS:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: true,
        drillData: action.data,
        error: null
      };
    case GET_CONVERSION_DRILL_DATA_FAIL:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: false,
        drillData: null,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/conversion.js